import '../styles/Pets-news.css';

const PetsNews = () => {
    return; 
};

export default PetsNews; 